import { useTranslations } from "ilenia";
import React from "react";

import { trackingConst } from "../../../constants";
import { useAnalytics } from "../../../utils/analytics";
import Menu from "../menu";
import { getCapitalizedUserInitials } from "./getUserInitials";
import { UserIcon, UserIconInitials } from "./styled";
import * as Types from "./types";
import UserSettingsDropdown from "./userSettingsDropdown";

const BusinessUser: React.FC<Types.User> = ({
  toggled,
  toggle,
  businessUser,
  useSimplifiedLayout,
  hasAppError,
  canViewBillingIngformation,
}) => {
  const [translations] = useTranslations();

  const analytics = useAnalytics();
  const toggleUserSettingsDropdown = React.useCallback(() => {
    if (!toggled) {
      analytics.track(trackingConst.events.buttonClicked, {
        context: "Business User Settings",
        name: "Open Business User Settings",
        placement: "header",
      });
    }
    toggle();
  }, [toggled, analytics]);

  return (
    <Menu
      toggled={toggled}
      toggle={toggleUserSettingsDropdown}
      target={
        <UserIcon
          appearance="subtle"
          ariaLabel={translations["BusinessUserSettings.accountSettings"]}
          aria-expanded={toggled}
          aria-controls="account-settings"
        >
          <UserIconInitials>{getCapitalizedUserInitials(businessUser?.name)}</UserIconInitials>
        </UserIcon>
      }
      testid="businessUserInfo"
    >
      <UserSettingsDropdown
        businessUser={businessUser}
        toggle={toggleUserSettingsDropdown}
        useSimplifiedLayout={useSimplifiedLayout}
        hasAppError={hasAppError}
        canViewBillingIngformation={canViewBillingIngformation}
      />
    </Menu>
  );
};

export default BusinessUser;
